export enum PdfViewerSlot {
  Edit = 'edit',
  Dialog = 'dialog',
  Splice = 'splice',
}
